import { Type } from 'class-transformer';

import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { DayOfWeekEnum } from '../../../shared/enums/day-of-week.enum';
import { DistanceUnitEnum } from '../../../shared/enums/distance-unit.enum';
import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { FuelConsumptionUnitEnum } from '../../shared/enums/fuel-consumption-unit.enum';
import { VehicleEmissionsUnitCO2Enum } from '../../vehicles/enums/vehicle-emissions-unit-co2.enum';
import { VehicleEngineOutputUnitEnum } from '../../vehicles/enums/vehicle-engine-output-unit.enum';
import { VehicleFuelTankCapacityUnitEnum } from '../../vehicles/enums/vehicle-fuel-tank-capacity-unit.enum';
import { ReservationCheckoutModeEnum } from '../enums/reservation-checkout-mode.enum';
import { ReservationPaymentAmountEnum } from '../enums/reservation-payment-amount.enum';

import { TenantSettingsDiscountsDto } from './tenant-settings-discounts.dto';
import { TenantSettingsIntegrationsDto } from './tenant-settings-integrations.dto';
import { TenantSettingsMarketingDto } from './tenant-settings-marketing.dto';
import { TenantSettingsReportsDto } from './tenant-settings-reports.dto';
import { TenantSettingsReservationPercentageDepositRoundingDto } from './tenant-settings-reservation-percentage-deposit-rounding.dto';

/**
 * Update settings DTO
 */
export class UpdateTenantSettingsDto {
  @TransformInt()
  id!: number;
  color?: string | null;

  shortDateFormat?: string | null;
  shortTimeFormat?: string | null;
  longDateFormat?: string | null;
  longTimeFormat?: string | null;
  firstDayOfWeek?: DayOfWeekEnum | null;
  timezone?: string | null;

  @TransformInt()
  amountDecimalDigits?: number | null;
  amountDecimalSeparator?: string | null;
  amountGroupSeparator?: string | null;

  @TransformFloat()
  standardTaxRate?: number | null;
  @TransformFloat()
  exemptTaxRate?: number | null;
  @TransformFloat()
  zeroTaxRate?: number | null;
  @TransformFloat()
  reducedTaxRate1?: number | null;
  @TransformFloat()
  reducedTaxRate2?: number | null;
  @TransformFloat()
  reducedTaxRate3?: number | null;
  @TransformFloat()
  reverseChargeTaxRate?: number | null;

  standardTaxRateLabel?: string | null;
  exemptTaxRateLabel?: string | null;
  zeroTaxRateLabel?: string | null;
  reducedTaxRate1Label?: string | null;
  reducedTaxRate2Label?: string | null;
  reducedTaxRate3Label?: string | null;
  reverseChargeTaxRateLabel?: string | null;

  isTaxIncluded?: boolean | null;
  defaultTaxRateType?: TaxRateTypeEnum | null;
  defaultRentalAgreementDurationUnit?: DurationUnitEnum | null;
  @TransformInt()
  minimumRentalAgreementDuration?: number | null;
  @TransformInt()
  maximumRentalAgreementDuration?: number | null;

  @TransformInt()
  availabilityThreshold?: number | null;

  reservationPaymentAmount?: ReservationPaymentAmountEnum | null;

  reservationMode?: ReservationCheckoutModeEnum | null;

  @Type(() => TenantSettingsReservationPercentageDepositRoundingDto)
  reservationPercentageDepositRounding?: TenantSettingsReservationPercentageDepositRoundingDto | null;

  distanceUnit?: DistanceUnitEnum | null;
  fuelConsumptionUnit?: FuelConsumptionUnitEnum | null;
  vehicleEmissionsUnitCO2?: VehicleEmissionsUnitCO2Enum | null;
  vehicleEngineOutputUnit?: VehicleEngineOutputUnitEnum | null;
  vehicleFuelTankCapacityUnit?: VehicleFuelTankCapacityUnitEnum | null;

  currencyIsoCode?: string | null;
  @TransformInt()
  defaultLanguageId?: number | null;
  @TransformInt()
  defaultCountryId?: number | null;

  logoUri?: string | null;

  @Type(() => TenantSettingsDiscountsDto)
  discounts?: TenantSettingsDiscountsDto | null;

  @Type(() => TenantSettingsMarketingDto)
  marketing?: TenantSettingsMarketingDto | null;

  @Type(() => TenantSettingsReportsDto)
  reports?: TenantSettingsReportsDto | null;

  @Type(() => TenantSettingsIntegrationsDto)
  integrations?: TenantSettingsIntegrationsDto | null;
}
